import { backdropAtom } from '@/commons/constants';
import VerifyTemplate from '@/templates/VerifyTemplate';
import { Backdrop, CircularProgress } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';

export default function VerifyContainer() {
  const location = useLocation();
  const [cookieStatus, setCookieStatus] = useState(false);
  const backdrop = useAtomValue(backdropAtom);

  useEffect(() => {
    const queryParam = new URLSearchParams(location.search);
    const connectSid = queryParam.get('connect.sid');
    const cookie = new Cookies();
    cookie.set('connect.sid', connectSid, { path: '/' });
    setCookieStatus(true);
  }, [location.search]);

  return cookieStatus ? (
    <>
      <VerifyTemplate />
      <Backdrop open={backdrop} sx={(theme) => ({ color: '#fff', zIndex: 100000 })}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  ) : (
    <></>
  );
}
